import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProductCopyDialogComponent } from '../components/product-copy-dialog/product-copy-dialog.component';
import type { Entity } from '../../core/models/entity.model';

@Injectable({
  providedIn: 'root'
})
export class CopyHoodToProjectService {
  constructor(private matDialog: MatDialog) {}

  public copyToProject(hood: Entity) {
    this.matDialog.open(ProductCopyDialogComponent, {
      data: { hood }
    });
  }
}
